import { createRouter, createWebHistory } from 'vue-router'
import MobileView from '../views/MobileView.vue'

const routes = [
  // 메인 홈 = 모바일 원페이지 랜딩
  {
    path: '/',
    name: 'home',
    component: MobileView,
    meta: { layout: 'mobile' }
  },
  // 사업소개 (탭: 사업개요, 브랜드)
  {
    path: '/intro/:sub',
    name: 'intro',
    component: () => import('../views/web/intro/IntroView.vue')
  },
  // 입지안내
  {
    path: '/location/environment',
    name: 'location',
    component: () => import('../views/web/location/LocationView.vue')
  },
  // 어라운드뷰
  {
    path: '/location/around',
    name: 'around',
    component: () => import('../views/web/location/AroundView.vue')
  },
  // 상품안내 (탭: 단지정보, 프리미엄, 커뮤니티)
  {
    path: '/product/:sub',
    name: 'product',
    component: () => import('../views/web/product/ProductView.vue')
  },
  // 세대안내 (59, 74, 84A, 84A-1, 84B)
  {
    path: '/type/:size',
    name: 'type',
    component: () => import('../views/web/type/TypeView.vue')
  },
  // 홍보센터
  {
    path: '/media/video',
    name: 'video',
    component: () => import('../views/web/media/VideoView.vue')
  },
  // 방문예약
  {
    path: '/reservation/register',
    name: 'reservation',
    component: () => import('../views/web/ReservationView.vue')
  },
  // 개인정보처리방침
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/web/PrivacyView.vue')
  },
  // 관리자
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  },
  // 기존 풀페이지 홈 (데스크톱 스크롤형)
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import('../views/HomeView.vue'),
    meta: { layout: 'home' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// 모비온 원태그 - SPA 페이지 이동 시 데이터매니저 호출
window['callDM'] = window['callDM'] || function () {
  (window['callDM'].q = window['callDM'].q || []).push(arguments)
}

router.afterEach(() => {
  window.callDM()
  // 네이버 로그분석 - SPA 페이지 전환 시 PV 전송
  if (window.wcs) {
    if (!window.wcs_add) window.wcs_add = {}
    window.wcs_add['wa'] = 's_4f499454e383'
    window.wcs.inflow()
    window.wcs_do()
  }
})

export default router
